// FLAGS: none
// Header rows for the check-in answer tables: date and total score.
import FormattedDate from "@src/components/FormattedDate";
import { getScoreColor } from "@src/theme/colors";
import { useTranslation } from "react-i18next";

interface ScrollInfoRowProps {
  date: string;
  scoreColumnName: string;
  score: number;
}

const ScrollInfoRow: React.FC<ScrollInfoRowProps> = ({
  date,
  scoreColumnName,
  score,
}) => {
  const { t } = useTranslation();

  if (!date || typeof score !== "number" || Number.isNaN(score)) {
    return null;
  }

  return (
    <>
      <tr>
        <th
          className="p-4 border-0 border-b-4 border-solid border-gray-200"
          scope="col"
        >
          <span className="sr-only">Question</span>
        </th>
        <th
          className="p-4 text-right font-medium text-base leading-6 border-0 border-b-4 border-solid border-gray-200"
          scope="col"
        >
          <FormattedDate date={date} />
        </th>
      </tr>
      <tr>
        <th className="p-4 text-left border-0 border-b-2 border-solid border-gray-200">
          <span className="text-sm font-medium">{t(scoreColumnName)}</span>
        </th>
        <td className="p-4 text-right border-0 border-b-2 border-solid border-gray-200">
          <span
            className="text-sm font-bold"
            style={{ color: getScoreColor(score) }}
          >
            {score.toFixed(1)}
          </span>
        </td>
      </tr>
    </>
  );
};

export default ScrollInfoRow;
